let currentStatus = 'before';
const ExhibitHeader = () => {
    // eslint-disable-next-line no-undef
    const { exhibitID } = exhibitVars;
    const wrapper = document.getElementById('exhibit-header');

    if (currentStatus && currentStatus === 'after' && wrapper) {
        return;
    }

    setInterval(async () => {
        const header = await (await fetch(`/2020/wp-json/wp/v2/exhibits-header?exhibit_id=${exhibitID}&skip_cache=1`)).json();
        const { status, content } = header;
        // Status has changed to during so update header
        if (content && currentStatus && currentStatus !== status && status === 'after') {
            wrapper.innerHTML = content;
        }
        currentStatus = status;
    }, 10000);
};

export default ExhibitHeader;
